import register from '../../../../global/js/registry';
export default register('m-formstep-warranty-step-3', () => import(/* webpackMode: "lazy" */ './m-formstep-warranty-step-3.controller'));
